import clsx from "clsx";
import { NavLink } from "react-router-dom";

interface NavStepProps {
    step: string;
    link: string;
    name: string;
}

const NavStep = ({ link, name, step }: NavStepProps) => {
    return (
        <NavLink to={link} end={true}>
            {({ isActive }) => (
                <div
                    className={clsx([
                        "group flex rounded-full p-2 space-x-1 h-[38px] items-center",
                        isActive && "bg-primary-500 text-white",
                        "hover:bg-primary-600 hover:text-white",
                    ])}
                >
                    <div
                        className={clsx(
                            "font-bold rounded-full w-6.5 h-6.5 flex items-center justify-center text-sm",
                            "bg-primary-200 text-primary-500 group-hover:bg-white",
                            isActive && "bg-white"
                        )}
                    >
                        {step}
                    </div>
                    <span className="mr-1 font-medium">{name}</span>
                </div>
            )}
        </NavLink>
    );
};

export default NavStep;
